import posthog from 'posthog-js'
import { getAnalyticsPreferences } from 'app/store/modules/cookiePreferences'

const is_gdpr_user = typeof window === 'undefined' ? {} : window.__is_gdpr_user__

/**
 * We get a lot of traffic and a lot of events.
 *
 * The following are fired a bunch and usually aren't critical to how
 * we are using and seeing value out of Posthog.
 *
 * By skipping them at this stage, we can still turn them back on
 * in the event that we need them.
 */
const EVENTS_TO_SKIP = [
  'main_navigation_link_click',
  'icon_search_view',
  'icon_discovery_view',
  'icon_html_code_copy_button_click',
  'icon_react_code_copy_button_click',
  'icon_vue_code_copy_button_click',
  'icon_svg_code_copy_button_click',
  'icon_preview_styling_update',
  'nudge_view'
]

const _posthog = posthog.init(FONTAWESOME.POSTHOG_PROJECT_API_KEY, {
  api_host: FONTAWESOME.POSTHOG_INSTANCE_ADDRESS,
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  disable_session_recording: true,
  loaded: function (ph) {
    if (isPostHogAllowed()) {
      ph.clear_opt_in_out_capturing()
    } else {
      ph.opt_out_capturing()
    }
  }
})

// If, for some reason, the preference isn't set, we default to true for non-EU users and false for EU users.
function isPostHogAllowed() {
  let preference = getAnalyticsPreferences()
  return preference === undefined ? !is_gdpr_user : preference
}

const _capture = _posthog.capture

_posthog.capture = function (...args) {
  const eventName = args[0]

  return EVENTS_TO_SKIP.includes(eventName) ? null : _capture.call(_posthog, ...args)
}

window.posthog = _posthog

export default _posthog
